var lib_core      = require("lib-core");
var THREE         = require("three");

var PositionHandleModel  = require("./../abstract/positionHandleModel.js");

var XHandleModel = function (editorModel, handleId, config) {
    PositionHandleModel.call(this, editorModel, handleId);
};

lib_core.inherit(XHandleModel, PositionHandleModel);
XHandleModel.$class = "XHandleModel";
module.exports = XHandleModel;

XHandleModel.prototype.getSubjectsRotation = function(){
    return this.getSubject().getRotation();
} 

XHandleModel.prototype.released = function(){
    this.selected(false);
}

XHandleModel.prototype.setContactPosition = function(position){
    this.startPosition = position;
    this.selected(true);

    var subject = this.getSubject();
    var basePos = subject.getPosition();
    this.contactOffset = this.startPosition.sub(basePos);
}

XHandleModel.prototype.createMovementPlane = function(ray, point){
    var newRay = new THREE.Vector3(0 , ray.direction.y, ray.direction.z);
    newRay.normalize();

    var zero = new THREE.Vector3();
    var subject = this.getSubject();
    var vecToOrigin = subject.getPosition().toThreejs();

    var distanceToOrigin = zero.distanceTo(vecToOrigin);
    vecToOrigin.normalize();
    var dotProduct = vecToOrigin.dot(newRay);
    var angle = Math.acos(dotProduct);
    var adjLength = distanceToOrigin * Math.cos(angle);
    this.movementPlane.setComponents(newRay.x, newRay.y, newRay.z, -adjLength);
}

XHandleModel.prototype.setMousePosition = function(position){

    var subject = this.getSubject();
    var basePos = subject.getPosition();

    subject.setX(position.sub(this.contactOffset).x);
}

